import script from "./ESIMProfiles.vue?vue&type=script&lang=ts&setup=true"
export * from "./ESIMProfiles.vue?vue&type=script&lang=ts&setup=true"

import "./ESIMProfiles.vue?vue&type=style&index=0&id=07a735b6&lang=scss"

const __exports__ = script;

export default __exports__